import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Toast } from 'vant'; // 轻提示
import { Dialog } from 'vant'; // 二次确认
import { NoticeBar } from 'vant';
import { List } from 'vant';
import { Swipe, SwipeItem } from 'vant'; // swiper
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'vant/lib/index.css'; // vant css
import '@/style/commen.scss'; // vant css
import "@/assets/font/font.css";
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


if (typeof EventTarget !== 'undefined') {
    const func = EventTarget.prototype.addEventListener
    EventTarget.prototype.addEventListener = function (type, fn, capture) {
        this.func = func
        if (typeof capture !== 'boolean') {
            capture = capture || {}
            capture.passive = false
        }
        this.func(type, fn, capture)
    }
}


app.use(createPinia())
app.use(router)
app.use(NoticeBar);
app.use(ElementPlus)
app.use(List);
app.use(Toast);
app.use(Swipe);
app.use(SwipeItem);
app.use(Dialog);
app.mount('#app')
